module.exports = __webpack_public_path__ + "static/media/guardians2.ec6a1fc4.jpeg";